import { render } from "./OrderPageRouter.vue?vue&type=template&id=7889bf51"
import script from "./OrderPageRouter.vue?vue&type=script&lang=js"
export * from "./OrderPageRouter.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__